/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_Notice_TextInputs */

const es_privacy_policy_intro_notice_text = /** @type {(inputs: Privacy_Policy_Intro_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vendemos sus datos personales a terceros bajo ninguna circunstancia. Nexata esta disenada desde cero con privacidad y seguridad como principios fundamentales.`)
};

const en_privacy_policy_intro_notice_text = /** @type {(inputs: Privacy_Policy_Intro_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We do not sell your personal data to third parties under any circumstances. Nexata is designed from the ground up with privacy and security as core principles.`)
};

/**
* | output |
* | --- |
* | "We do not sell your personal data to third parties under any circumstances. Nexata is designed from the ground up with privacy and security as core principles." |
*
* @param {Privacy_Policy_Intro_Notice_TextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_notice_text = /** @type {((inputs?: Privacy_Policy_Intro_Notice_TextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_Notice_TextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_notice_text(inputs)
	return en_privacy_policy_intro_notice_text(inputs)
});
export { privacy_policy_intro_notice_text as "privacy_policy.intro.notice_text" }